import { Button, SxProps, Theme, Typography } from '@mui/material';
import { baseColors } from 'utils/constants';

type Props = {
  id?: string;
  sx?: SxProps<Theme> | undefined;
  children?: React.ReactNode;
  onClick?: () => void;
};

const SubButton = (props: Props) => {
  const { sx, children, onClick } = props;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    onClick && onClick();
  };

  return (
    <Button
      sx={{
        width: 76,
        height: 30,
        m: 0,
        p: 0.5,
        textAlign: 'center',
        bgcolor: baseColors.orange,
        borderRadius: '6px',
        ...sx
      }}
      onClick={handleClick}
    >
      <Typography
        variant="caption"
        sx={{
          display: 'flex',
          color: baseColors.white
        }}
      >
        {children ? children : '修正する'}
      </Typography>
    </Button>
  );
};

export default SubButton;
